import { useInfiniteQuery } from '@tanstack/react-query';
import { PaginatedResponse } from 'common/types';

import { useRequest } from '@frontend/api';
import type { InfiniteQueryFunction } from '@frontend/api';

import type { PurchasedComponent } from './types';

export type PurchasedComponentsListQueryKey = readonly [
  'quotes',
  'components',
  'purchasedComponentsSearch',
  string,
  any,
];

export const getPurchasedComponentsListKey = (
  groupId: string,
  query: any,
): PurchasedComponentsListQueryKey => [
  'quotes',
  'components',
  'purchasedComponentsSearch',
  groupId,
  query,
];

export type PurchasedComponentsListParams = [groupId: string];

export const usePurchasedComponentsList: InfiniteQueryFunction<
  PaginatedResponse<PurchasedComponent>,
  PurchasedComponentsListParams,
  PurchasedComponentsListQueryKey
> = (groupId, { requestOptions, queryOptions, query } = {}) => {
  const formattedQuery = Object.fromEntries(new URLSearchParams(query ?? ''));
  const queryKey = getPurchasedComponentsListKey(groupId, formattedQuery);
  const request = useRequest(requestOptions);

  return useInfiniteQuery({
    queryKey,
    queryFn: ({ signal, pageParam = 1 }) =>
      request(`/suppliers/${groupId}/purchased_components`, {
        init: {
          signal,
        },
        query: new URLSearchParams({
          page: pageParam,
          ...formattedQuery,
        }).toString(),
      }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.next ? allPages.length + 1 : undefined;
    },
    ...queryOptions,
  });
};
